export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq'
  },
  {
    title: that.$l('table_depName') || '业务部门',
    field: 'depName',
    minWidth: 90,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_rateOfProgress') || '预算完成率',
    field: 'completionRate',
    minWidth: 220,
    headerAlign: 'center',
    align: 'left',
    sortable: true,
    sortType: 'number',
    slots: { default: 'rateOfProgress' }
  },
  {
    title: that.$l('table_budgetAmount') || '预算总额',
    field: 'annualBudget',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
    slots: { default: 'showBudget' }
  },
  {
    title: that.$l('table_salePriceAmount') || '订单金额',
    field: 'orderAmount',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number',
    slots: { default: 'showSales' }
  }
]
